module.exports = __webpack_public_path__ + "img/dummy475x490@2x.954afb0c.png";